import { BaseProduct } from '../types';

type GetMetafieldAsNumber = (baseProduct: BaseProduct | void) => number;
type GetMaxHeightAsNumber = (
  baseProduct: BaseProduct | void,
  width: number,
) => number;
type widthHeightConfig = {
  minWidth: number;
  maxWidth: number;
  maxHeight: number;
}[];
type GetHeightBasedOnWidth = (
  baseProduct: BaseProduct | void,
  width: number,
) => number | void;

export const getMinWidth: GetMetafieldAsNumber = baseProduct =>
  baseProduct ? parseInt(baseProduct.metafields.min_width || '') : NaN;

export const getMaxWidth: GetMetafieldAsNumber = baseProduct =>
  baseProduct ? parseInt(baseProduct.metafields.max_width || '') : NaN;

export const getSmartglideMaxWidth: GetMetafieldAsNumber = baseProduct =>
  baseProduct
    ? parseInt(baseProduct.metafields.roller_smart_glide_max_width || '')
    : NaN;

export const getRollerDayNightMaxWidth: GetMetafieldAsNumber = baseProduct =>
  baseProduct
    ? parseInt(baseProduct.metafields.roller_day_night_max_width || '')
    : NaN;

export const getMinHeight: GetMetafieldAsNumber = baseProduct =>
  baseProduct ? parseInt(baseProduct.metafields.min_height || '') : NaN;

export const getMaxHeight: GetMaxHeightAsNumber = (baseProduct, width) =>
  baseProduct
    ? getHeightBasedOnWidth(baseProduct, width) ||
      parseInt(baseProduct.metafields.max_height || '')
    : NaN;

export const getHeightBasedOnWidth: GetHeightBasedOnWidth = (
  baseProduct,
  width,
) => {
  if (
    !baseProduct ||
    !baseProduct.metafields.max_height_range ||
    !baseProduct.metafields.max_width_range
  )
    return;

  const widthHeightConfig: widthHeightConfig = [];

  baseProduct.metafields.max_height_range.forEach((element, index) => {
    const width_range =
      baseProduct.metafields.max_width_range &&
      baseProduct.metafields.max_width_range[index]
        ? baseProduct.metafields.max_width_range[index]
        : '';

    const widthParts = width_range.split('-');
    widthHeightConfig.push({
      minWidth: widthParts[0] ? parseInt(widthParts[0]) : NaN,
      maxWidth: widthParts[0] ? parseInt(widthParts[1]) : NaN,
      maxHeight: parseInt(element),
    });
  });

  for (const el of widthHeightConfig) {
    if (el.minWidth <= width && width <= el.maxWidth) {
      return el.maxHeight;
    }
  }

  return;
};
